"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var Parser_1 = require("../Parser");

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var ArrayParser_1 = require("./ArrayParser");

var SetParser =
/*#__PURE__*/
function (_Parser_1$Parser) {
  _inherits(SetParser, _Parser_1$Parser);

  function SetParser(members) {
    var _this;

    _classCallCheck(this, SetParser);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SetParser).call(this));
    _this.members = members;
    return _this;
  }

  _createClass(SetParser, [{
    key: "parse",
    value: function parse(input, level) {
      var _this2 = this,
          _immutable_1$Set;

      if (input instanceof immutable_1.Set) {
        var suc = new ValidationResult_1.ValidationSuccess(undefined);
        var res = input.reduce(function (r, v) {
          return r.map(function () {
            return _this2.members.validate(v, level);
          });
        }, suc);

        if (!res.valid) {
          return res;
        }

        return new ValidationResult_1.ValidationSuccess(input);
      }

      if (!Array.isArray(input)) {
        return new ValidationResult_1.ValidationError(ArrayParser_1.ArrayParser.NOT_AN_ARRAY_ERROR);
      }

      var ret = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var item = _step.value;
          var m = this.members.validate(item, level || ValidationLevel_1.ValidationLevel.Basic);

          if (!m.valid) {
            return m;
          }

          ret.push(m.value);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return new ValidationResult_1.ValidationSuccess((_immutable_1$Set = immutable_1.Set).of.apply(_immutable_1$Set, ret));
    }
  }]);

  return SetParser;
}(Parser_1.Parser);

exports.SetParser = SetParser;